import Beneficiary from '@/modules/beneficiary/pages/Beneficiary.vue';
import routes from '@/modules/beneficiary/beneficiary-routes';
import store from '@/modules/beneficiary/beneficiary-store';

export default {
    components: [Beneficiary],
    routes,
    store,
};
